import type { TestGroupingItem } from '@vedalib/editor/lib/elements'
import { FileUsageSource } from '@vedalib/editor/lib/files'
import { generateId } from '@vedalib/editor/lib/utils/id'
import { textToRtValue } from '@vedalib/rich-text'
import React, { useCallback } from 'react'

import { IRenderButtonAddItem } from 'components/uiKit/ArrayControl/types'
import Button from 'components/uiKit/Button'
import { KitSize } from 'components/uiKit/KitTypes'
import { t } from 'services/Translation'

import { useGroupingFormValueSetElementState } from './TestGroupingFormValueContext'

const TestGroupingFormValueAddAnswer: React.FC<IRenderButtonAddItem<TestGroupingItem>> = ({
  name,
  max,
  array,
  onChange,
}) => {
  const setElementState = useGroupingFormValueSetElementState()

  const handleAdd = useCallback(() => {
    const newId = generateId()
    const item: TestGroupingItem = {
      value: newId,
      label: textToRtValue(`${t('elements.grouping.form.answer')} ${array.length + 1}`),
      image: {
        source: FileUsageSource.file,
        id: '',
        accessibility: '',
      },
      overlay: null,
    }

    onChange?.([item, ...array], { command: 'add', item })

    setElementState?.({ answersOrder: [newId] })
  }, [onChange, setElementState, array])

  return (
    <Button
      disabled={Boolean(max && array.length >= max)}
      name={`${name}.addItem`}
      onClick={handleAdd}
      size={KitSize.L}
      styleType='secondary'
      fluid
    >
      {t('uiKit.button.add')}
    </Button>
  )
}

export default React.memo(TestGroupingFormValueAddAnswer) as typeof TestGroupingFormValueAddAnswer
